/** Известные MIME → расширение для атрибута download */
export const MIME_TO_DOWNLOAD_FILE_EXTENSION: Partial<Record<string, string>> = {
    'application/pdf': 'pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/zip': 'zip',
}

export const getDownloadFileExtensionFromMime = (mimeType: string): string | undefined =>
    MIME_TO_DOWNLOAD_FILE_EXTENSION[mimeType]

/**
 * Сохраняет blob как файл в браузере без навигации (через временный object URL).
 */
export const downloadBlobAsFile = (blob: Blob, filename: string): void => {
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = filename
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(objectUrl)
}
